var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"app-container",attrs:{"src":_vm.activeApp,"width":"100%","height":"100%","frameborder":"0","onload":"document.getElementById('spinner').style.display='none';"}},[_vm._v("Browser not compatible.")])}
var staticRenderFns = []

export { render, staticRenderFns }